import { createMap, partition } from "../utils/array"
import { DatalayersMap } from "./datalayersMap"
import { LayerViewModel } from "./layerViewModel"
import { IDataLayer, IDatalayerContext, ILayerViewModelOptions } from "./types"

export type LayerViewModelFactory = ReturnType<typeof createLayerViewModelFactory>

export function createLayerViewModelFactory(context: IDatalayerContext) {

    const [fields, cropping] = partition(context.getAllFields(), a => a.isField())

    const fieldsMap = createMap(fields, f => f.fieldId)
    const croppingMap = createMap(cropping, c => c.croppingId)

    return function createLayerViewModel(map: DatalayersMap, layer: IDataLayer, options?: ILayerViewModelOptions) {

        const fieldViewModel = layer.CroppingId
            ? croppingMap.get(layer.CroppingId)
            : layer.FieldId
                ? fieldsMap.get(layer.FieldId)
                : undefined

        return new LayerViewModel(context, map, layer, fieldViewModel, options)

    }

}
